import React from 'react'

export default function Resources() {
  return (
    <>
      <div style={{ margin: '0 5vw 5vh 5vw', height: '75vh' }}>

        <div style={{ backgroundColor: 'rgb(255, 255, 255, .7)', borderRadius: '2%/5%', padding: '1vh 2vw', marginBottom: '2vh' }}>
          <a style={{ color: '#0B3978' }} target="_blank" rel="noreferrer" href="https://therapyforblackgirls.com/">
            <h5>Therapy for Black Girls</h5>
          </a>
          <p>So often the stigma surrounding mental health issues and therapy prevents Black women from taking the step of seeing a therapist. This space was developed to present mental health topics in a way that feels more accessible and relevant.
          </p>
        </div>

        <div style={{ backgroundColor: 'rgb(255, 255, 255, .7)', borderRadius: '2%/5%', padding: '1vh 2vw' }}>
          <a style={{ color: '#0B3978' }} target="_blank" rel="noreferrer" href="https://therapyforblackmen.org/">
            <h5>Therapy for Black Men</h5>
          </a>
          <p>
            At TherapyforBlackMen.org, we want to break the stigma that asking for help is a sign of weakness. With a rapidly growing directory of 591 therapists and 57 coaches throughout the fifty states thus far, we are here to provide judgment-free, multiculturally-competent care to Black men. You don’t have to man up. Let’s talk it through together.
          </p>
        </div>

        <div style={{ backgroundColor: 'rgb(255, 255, 255, .7)', borderRadius: '2%/5%', padding: '1vh 2vw' }}>
          <a style={{ color: '#0B3978' }} target="_blank" rel="noreferrer" href="https://www.forthegworls.party/home">
            <h5>For the Gworls</h5>
          </a>
          <p>We are a Black, trans-led collective that curates parties to fundraise money to help Black transgender people pay for their rent, gender-affirming surgeries, smaller co-pays for medicines/doctor’s visits, and travel assistance.
          </p>
        </div>

        <div style={{ backgroundColor: 'rgb(255, 255, 255, .7)', borderRadius: '2%/5%', padding: '1vh 2vw 10vh 2vw' }}>
          <a style={{ color: '#0B3978' }} target="_blank" rel="noreferrer" href="https://www.nami.org/Support-Education/Mental-Health-Education/NAMI-Sharing-Hope-Mental-Wellness-in-the-Black-Community">
            <h5>NAMI: National Alliance on Mental Illness</h5>
            <p>Sharing Hope Video Series</p>
          </a>
          <p>Lack of information surrounding mental health issues can prevent people in Black communities from getting the help and support they need. Sharing Hope is a three-part video series that explores the journey of mental wellness in Black communities through dialogue, storytelling and a guided discussion on the following topics:
            Youth and Mental Wellness: “How Do You Heal?”
            Community Leaders and Mental Wellness: “The Art of Healing”
            Black Families and Mental Wellness: “Smiling On Our Journey”
          </p>
        </div>
      </div>
    </>
  )
}
